import { useEffect, useRef } from "react";
import { gsap } from "gsap";
import "./general.css";

export default function ScrollIndicator() {
  const indicatorRef = useRef(null);

  useEffect(() => {
    const updateScrollProgress = () => {
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const scrollableHeight = documentHeight - windowHeight;
      const progress = scrollableHeight > 0 ? (scrollTop / scrollableHeight) * 100 : 0;

      if (indicatorRef.current) {
        gsap.to(indicatorRef.current, {
          width: `${Math.min(100, Math.max(0, progress))}%`,
          duration: 0.1,
          ease: "none",
        });
      }
    };

    // Utiliser requestAnimationFrame pour de meilleures performances
    let rafId = null;
    const handleScroll = () => {
      if (rafId) return;
      rafId = requestAnimationFrame(() => {
        updateScrollProgress();
        rafId = null;
      });
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    updateScrollProgress(); // Initial update

    return () => {
      window.removeEventListener("scroll", handleScroll);
      if (rafId) {
        cancelAnimationFrame(rafId);
      }
    };
  }, []);

  return (
    <div className="scroll-indicator-wrapper">
      <div ref={indicatorRef} className="scroll-indicator" />
    </div>
  );
}

